import { IBasicUserType } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledFieldset = styled.fieldset<IBasicUserType>`
  margin: 0;
  border: none;
  padding: 0;
`;

export const StyledTitle = styled.h4`
  margin: ${rem('40px')} 0 0 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('20px')};
  font-weight: 600;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: row;
    min-height: 100vh;
  }
`;
